/**
 * Version Check Service
 * Überprüft auf neue Versions-Tags und löscht den Cache bei Bedarf
 */

const VERSION_KEY = "app_version";
const VERSION_CHECK_INTERVAL = 60000; // 1 Minute

export const initVersionCheck = async () => {
  // Service Worker komplett entfernen - verursacht Login-Probleme
  await deregisterAllServiceWorkers();

  // Beim Start prüfen
  await checkAndClearCacheIfNeeded();

  // Dann regelmäßig prüfen
  setInterval(checkAndClearCacheIfNeeded, VERSION_CHECK_INTERVAL);
};

const deregisterAllServiceWorkers = async () => {
  // Service Worker KOMPLETT entfernen - verursacht Login-Probleme
  if ("serviceWorker" in navigator) {
    try {
      const registrations = await navigator.serviceWorker.getRegistrations();
      console.log(`[versionCheck] Gefunden: ${registrations.length} Service Worker`);
      for (let registration of registrations) {
        const success = await registration.unregister();
        console.log(`[versionCheck] Service Worker deregistriert: ${success}`);
      }
      // Caches auch komplett löschen
      if ('caches' in window) {
        const cacheNames = await caches.keys();
        for (const cacheName of cacheNames) {
          await caches.delete(cacheName);
          console.log(`[versionCheck] Cache gelöscht: ${cacheName}`);
        }
      }
    } catch (error) {
      console.error("[versionCheck] Fehler beim Deregistrieren:", error);
    }
  }
};

const checkAndClearCacheIfNeeded = async () => {
  try {
    // Hole die aktuelle Version vom Server (ohne Cache)
    const response = await fetch("/version.json", {
      cache: "no-store",
      headers: {
        "Cache-Control": "no-cache, no-store, must-revalidate",
      },
    });

    if (!response.ok) {
      console.warn("[versionCheck] version.json nicht gefunden");
      return;
    }

    const data = await response.json();
    const newVersion = data.version;

    // Hole die gespeicherte Version
    const storedVersion = localStorage.getItem(VERSION_KEY);

    console.log(
      `[versionCheck] Stored: ${storedVersion}, Current: ${newVersion}`
    );

    if (storedVersion && storedVersion !== newVersion) {
      console.log("[versionCheck] Neue Version erkannt! Cache wird geleert...");

      // Speichere neue Version
      localStorage.setItem(VERSION_KEY, newVersion);

      // Lösche alle Caches
      await clearAllCaches();

      // Seite neu laden
      window.location.reload(true);
    } else if (!storedVersion) {
      // Beim ersten Mal speichern
      localStorage.setItem(VERSION_KEY, newVersion);
      console.log(`[versionCheck] Erste Version gespeichert: ${newVersion}`);
    }
  } catch (error) {
    console.error("[versionCheck] Fehler beim Versionsabgleich:", error);
  }
};

const clearAllCaches = async () => {
  console.log("[versionCheck] Starte Cache-Löschung...");

  // 1. Service Worker bitten, seine Caches zu löschen
  if (navigator.serviceWorker && navigator.serviceWorker.controller) {
    try {
      navigator.serviceWorker.controller.postMessage({
        type: "CLEAR_CACHE",
      });
      console.log("[versionCheck] Service Worker aufgefordert, Cache zu löschen");
    } catch (error) {
      console.error("[versionCheck] Fehler beim Service Worker Cache-Clear:", error);
    }
  }

  // 2. Browser Caches direkt löschen
  try {
    if ("caches" in window) {
      const cacheNames = await caches.keys();
      console.log(`[versionCheck] Lösche ${cacheNames.length} Browser-Caches...`);

      for (const cacheName of cacheNames) {
        await caches.delete(cacheName);
        console.log(`[versionCheck] Cache gelöscht: ${cacheName}`);
      }
    }
  } catch (error) {
    console.error("[versionCheck] Fehler beim Löschen der Caches:", error);
  }

  // 3. LocalStorage-basierte Caches löschen (außer Version)
  try {
    const keysToDelete = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key !== VERSION_KEY && (key.startsWith("cache_") || key.startsWith("api_"))) {
        keysToDelete.push(key);
      }
    }

    keysToDelete.forEach((key) => {
      localStorage.removeItem(key);
      console.log(`[versionCheck] LocalStorage gelöscht: ${key}`);
    });
  } catch (error) {
    console.error("[versionCheck] Fehler beim Löschen von LocalStorage:", error);
  }

  // 4. Service Worker selbst aktualisieren
  if (navigator.serviceWorker) {
    try {
      const registration = await navigator.serviceWorker.getRegistration();
      if (registration) {
        await registration.update();
        console.log("[versionCheck] Service Worker aktualisiert");
      }
    } catch (error) {
      console.error("[versionCheck] Fehler beim Service Worker Update:", error);
    }
  }
};

export default { initVersionCheck };
